module.exports = __webpack_public_path__ + "img/main.f2d14e1b.png";